import {MerchantData} from '@src/store/merchant/type'

export const initialData: MerchantData = {
  deviceId: undefined,
  fingerprintError: undefined,
  input: {
    accepted_terms: undefined,
    address: undefined,
    business_corporate_name: undefined,
    business_name: undefined,
    business_number: undefined,
    email: undefined,
    gmv: undefined,
    has_password: false,
    provider: undefined,
    redirect_url: undefined,
    responsible: undefined,
    sector: undefined,
    segment: undefined,
    status: undefined,
    url: undefined
  },
  leadId: undefined,
  origin: undefined,
  otp: undefined,
  returnToPassword: false
}
